<template>
    <SmartLinkItemComponent :id="model?.system?.id" :component="!model.system.workflow" v-if="model">
        <div class="split-content-block" :class="backgroundColor">
            <div class="container" :class="{'pt-0': paddingModifications['pt-0'], 'pb-0': paddingModifications['pb-0']}">
                
                <div class="row" v-if="data.title">
                    <div class="col-lg" data-aos="fade-in">
                        <SmartLinkStandaloneElement :codename="type.elements.title.codename">
                            <h2 class="title">
                                {{ data.title }}
                            </h2>
                        </SmartLinkStandaloneElement>
                    </div>
                </div>
 
                <div class="row">
                    <div class="left-col" :class="[block_styling[0], mobile_block_styling[0]]" data-aos="fade-in">
                        <SmartLinkStandaloneElement :codename="type.elements.left_content.codename">
                            <RichText :value="data.leftContent" />
                        </SmartLinkStandaloneElement>
                    </div>
                    <div class="right-col" :class="[block_styling[1], mobile_block_styling[1]]" data-aos="fade-in">
                        <SmartLinkStandaloneElement :codename="type.elements.right_content.codename">
                            <RichText :value="data.rightContent" />
                        </SmartLinkStandaloneElement>
                    </div>
                </div>
                
            </div>
        </div>
    </SmartLinkItemComponent>
</template>
<script lang="ts" setup>
import { provide } from 'vue'
import { contentTypes, type SplitContentBlockModel } from '~~/app/models'
import SmartLinkStandaloneElement from '../smart-links/SmartLinkStandaloneElement.vue'

provide('isSplitContentBlock', true)

const pageStore = usePageStore()
const type = contentTypes.split_content_block
const props = defineProps<{ model: SplitContentBlockModel }>()

const data = {
    title: props.model.elements?.title?.value,
    leftContent: props.model?.elements?.left_content?.value,
    rightContent: props.model?.elements?.right_content?.value,
    blockStyling: props.model.elements?.layout?.value,
    mobileStyling: props.model.elements?.mobile_layout?.value,
    paddingOptions: props.model.elements?.padding_modifications__padding_modifications,
    background: props.model.elements?.background?.value
}

const block_styling = computed(() => {
    switch (firstOrDefault(data.blockStyling)?.codename) {
        case 'n70_30':
            return ['col-lg-8', 'col-lg-4']
        case 'n30_70':
            return ['col-lg-4', 'col-lg-8']
        case 'n50_50':
            return ['col-lg-6', 'col-lg-6']
        default:
            return ['col-lg-6', 'col-lg-6']
    }
})

const mobile_block_styling = computed(() => {
    switch (firstOrDefault(data.mobileStyling)?.codename) {
        case 'left_content_on_top':
            return ['', '']
        case 'right_content_on_top':
            return ['order-lg-1 order-2', 'order-lg-2 order-1']
        default:
            return ['', '']
    }
})

const paddingModifications = computed(() =>
    getPaddingModifications(props.model.elements.padding_modifications__padding_modifications)
)

const backgroundColor = computed(() => {
    switch (firstOrDefault(props?.model?.elements?.background?.value)?.codename) {
        case 'light':
            return 'bg-white';
        case 'dark':
            return 'bg-navy';
        default:
            return '';
    }
});
</script>